<template>
  <div class="">

    <tabs class="d-none d-md-block button-tabs" align="center">
      <tab name="Email">
        <div class="email-preview-content my-3 mx-auto">
          <div
            v-html="content"
          />
        </div>
      </tab>
      <tab name="Web">
        <iframe class="my-3" style="border: 0;" border="0" width="100%" height="1500" :src="previewUrl" />
      </tab>
      <tab v-if="!!article.source" name="Source">
        <view-source :data="article"></view-source>
      </tab>
    </tabs>

    <!-- Mobile test button -->
    <div class="d-flex d-md-none preview-send-test">
      <button
        class="d-block d-md-none btn btn-outline-primary btn-email-test"
        @click="$emit('send-test')"
      >
        Send yourself test email
      </button>
    </div>
  </div>
</template>

<script>
import gateway from '@/gateway'
import Tab from '@/components/Tab'
import Tabs from '@/components/Tabs'
import ViewSource from '../Source'

export default {
  name: 'PublishStep',

  components: {
    Tab,
    Tabs,
    ViewSource,
  },

  props: {
    article: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      activePreview: 'email',
      content: '',
    }
  },

  created () {
    this.getEmailPreview()
  },

  activated () {
    this.activePreview = 'email'
    this.getEmailPreview()
  },

  computed: {
    previewUrl () {
      return this.insightsUrl(`article/${this.article.article_draft_id}/preview?tellimer`)
    }
  },

  methods: {
    setActivePreview (type = 'email') {
      this.activePreview = type

      this.content = ''
      if (type === 'email') {
        this.getEmailPreview()
      }
    },

    insightsUrl (url) {
      return `${process.env.VUE_APP_INSIGHTS_URL}${url}`
    },

    async getEmailPreview () {
      const url = `/alerts/previews/${this.article.article_draft_id}/article-draft`
      const {data} = await gateway.get(url)
      this.content = data.data.html
    },

  },
}
</script>

<style lang="scss">
.preview-switcher {
  margin-bottom: 1rem;
  .btn {
    width: 6rem;
    font-weight: normal;
    box-shadow: none;
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}

.preview-send-test {
  height: 200px;
  width: 100%;
  align-items: center;
  justify-content: center;

  .btn {
    width: 100%;
    flex: 1;
  }
}

.preview-content {
  width: 600px;
  margin: 0 auto;
}
</style>


